(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teendow-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get("teendow-video-carousel")) {
    class TeendowVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.finePointer = window.matchMedia("(pointer: fine)");
        this.dialog = this.querySelector("dialog");
        this.dialogContent = this.querySelector(".teendow-video-carousel__dialog-content");
        this.cards = Array.from(this.querySelectorAll(".teendow-video-carousel__card"));

        this.cards.forEach((card) => {
          card.addEventListener("click", this.openDialog.bind(this), { signal: this.abortController.signal });
          card.addEventListener("mouseenter", this.playPreview.bind(this), { signal: this.abortController.signal });
          card.addEventListener("mouseleave", this.pausePreview.bind(this), { signal: this.abortController.signal });
          card.addEventListener("blur", this.pausePreview.bind(this), { signal: this.abortController.signal });
        });

        this.dialog?.addEventListener("click", this.onDialogClick.bind(this), { signal: this.abortController.signal });
        this.dialog?.addEventListener("close", this.resetDialog.bind(this), { signal: this.abortController.signal });
        this.querySelector("[data-dialog-close]")?.addEventListener("click", () => this.closeDialog(), { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController.abort();
        this.resetDialog();
      }

      visibleVideos(card) {
        return Array.from(card.querySelectorAll("video")).filter((video) => video.getClientRects().length > 0);
      }

      playPreview(event) {
        if (!this.finePointer.matches) {
          return;
        }

        const card = event.currentTarget;
        const videos = this.visibleVideos(card);

        if (videos.length === 0) {
          return;
        }

        videos.forEach((video) => {
          video.muted = true;
          video.play().then(() => {
            card.classList.add("is-preview-playing");
          }).catch(() => {});
        });
      }

      pausePreview(event) {
        const card = event.currentTarget;

        card.classList.remove("is-preview-playing");

        this.visibleVideos(card).forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
      }

      openDialog(event) {
        const card = event.currentTarget;
        const template = document.getElementById(card.dataset.templateId);

        if (!template || !this.dialog || !this.dialogContent) {
          return;
        }

        this.pausePreview({ currentTarget: card });
        this.cards.forEach((item) => item.setAttribute("aria-expanded", "false"));
        card.setAttribute("aria-expanded", "true");
        this.dialogContent.replaceChildren(template.content.cloneNode(true));

        const media = this.dialogContent.querySelector(".teendow-video-carousel__dialog-media");
        const ratio = Number(media?.dataset.aspectRatio) || 1.777777;
        const maxWidthByHeight = Math.max(280, (window.innerHeight - 32) * ratio);

        this.dialog.style.setProperty("--teendow-video-carousel-dialog-ratio", String(ratio));
        this.dialog.style.setProperty("--teendow-video-carousel-dialog-max-width", `${maxWidthByHeight}px`);

        if (typeof this.dialog.showModal === "function") {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute("open", "");
        }

        document.documentElement.classList.add("lock");
        this.scrollLocked = true;

        const video = Array.from(this.dialogContent.querySelectorAll("video")).find((item) => item.getClientRects().length > 0);
        video?.play().catch(() => {});
      }

      closeDialog() {
        if (this.dialog?.open) {
          this.dialog.close();
        } else {
          this.resetDialog();
        }
      }

      onDialogClick(event) {
        if (event.target === this.dialog) {
          this.closeDialog();
        }
      }

      resetDialog() {
        this.cards?.forEach((card) => card.setAttribute("aria-expanded", "false"));
        this.dialogContent?.querySelectorAll("video").forEach((video) => video.pause());
        this.dialogContent?.replaceChildren();
        this.dialog?.style.removeProperty("--teendow-video-carousel-dialog-ratio");
        this.dialog?.style.removeProperty("--teendow-video-carousel-dialog-max-width");

        if (this.scrollLocked) {
          document.documentElement.classList.remove("lock");
          this.scrollLocked = false;
        }
      }
    }

    window.customElements.define("teendow-video-carousel", TeendowVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
